import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {admin_update_status} from "../Enums/api_constunts"
import _ from "lodash";
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";

import {postMethod} from "../Helpers/services"
export default function ProfileInfo({ fetchData,openUpdatePassword = true, SetOpenUpdatePassword,selectedItem }) {
  const userData = useSelector((state) => state.auth.user);
  const [isSpinner, setIsSpinner] = useState(false);
  const [showModal, SetShowModal] = useState(openUpdatePassword === 1);
  
  const update_status_action = ()=>{
    let url = admin_update_status
    
    let post_data = {
      "user_id":_.get(selectedItem,"id"),
      "status_id":_.get(selectedItem,"status_id")==3?4:3
    }
    setIsSpinner(true)
    postMethod(url,post_data).then((result)=>{
      fetchData()
      showToast("success",_.get(result, "message","Something went wrong!"))

       setIsSpinner(false);
       SetOpenUpdatePassword(0)
       
       
     }).catch((error)=>{
       showToast("error",_.get(error, "message","Something went wrong!"))
       setIsSpinner(false);
       
     })
  }
  
  return (
    <Modal size="lg" show={showModal} onHide={() => SetOpenUpdatePassword(0)} centered >
      <Modal.Header closeButton>
        <Modal.Title>{_.get(selectedItem,"status_id")==3?"Deactivate user?":_.get(selectedItem,"status_id")>3?"Activate User?":" do this action ?"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <div className="row justify-content-center">
            
            <div className="col-md-10">
              {/* Confirmation Message */}
              <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                  <label className="form-label" style={{ width: "auto" }}>
                    Are you sure you want to {_.get(selectedItem,"status_id")==3?"Deactivate this user?":_.get(selectedItem,"status_id")>3?"Activate this user?":" do this action ?"} 
                  </label>
                </div>
              </div>
              {/* Action Buttons */}

              <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton label="No" onClick={()=>SetOpenUpdatePassword(0)} className="btn btn-secondary" />
              <PrimaryButton
                type="submit"
                onClick={update_status_action}
                spinner={isSpinner}
                label="Yes"
                disabled={isSpinner}
              />
            </div>
              {/* <div className="d-flex justify-content-between">
                <Button
                  variant="secondary"
                  onClick={() => SetOpenUpdatePassword(0)}
                  className="px-4"
                >
                  No
                </Button>
                <Button
                  variant="primary"
                  onClick={update_status_action}
                  className="px-4"
                >
                  Yes
                </Button>
              </div> */}
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
